import React, { ForwardedRef, forwardRef } from 'react';
import { Box, FormControl, FormLabel } from '@chakra-ui/react';
import { useController, useFormState } from 'react-hook-form';
import { get } from 'lodash';
import { FieldProps } from './Field.types';
import { Error } from './Error';

function FieldInner<T>(
  {
    control,
    name,
    label,
    rules,
    component: Component,
    labelProps,
    wrapProps,
    containerProps,
    t,
    ...props
  }: FieldProps<T>,
  ref: ForwardedRef<any>,
) {
  const { field, fieldState, formState } = useController({
    control,
    name,
    rules,
  });

  const { errors } = useFormState({
    control,
    name,
  });

  return (
    <Box {...wrapProps}>
      <FormControl isInvalid={!!get(errors, name)} {...containerProps}>
        {label && (
          <FormLabel htmlFor={name} {...labelProps}>
            {label}
          </FormLabel>
        )}
        <Component
          errors={get(errors, name)}
          {...props}
          {...field}
          ref={ref}
          onChange={props.onChange || field.onChange}
          fieldState={fieldState}
          formState={formState}
        />
        <Error t={t} errors={errors} name={name} />
      </FormControl>
    </Box>
  );
}

export const Field = forwardRef(FieldInner as never) as <T>(
  props: FieldProps<T> & { ref?: ForwardedRef<any> },
) => React.JSX.Element;
